import type { MutableRefObject } from 'react';
import { CONTRACT_STATUS, IContractBase } from 'services/contract/types';
import { IAgreementTemplatetAggregatorForm } from 'services/templates/agreement-template/types';
import {
  IInfinitePageParams,
  IInfinitePageResponse,
  IVersion,
} from 'services/types';

export type IContractTemplateTreeItemForm = {
  id: string;
  children: IContractTemplateTreeItemForm[];
  disabled?: boolean;
  disabledInput?: boolean;
  disabledSelection?: boolean;
  disabledCollapse?: boolean;
  disabledRemove?: boolean;
  disabledMoreButton?: boolean;
  disableDisplayDetail?: boolean;
  collapsed?: boolean;
  autoFocus?: boolean;
  settlementType?: SETTLEMENT_TYPE;
} & (
  | {
      type: TEMPLATE_TYPE.agreement;
      content: IAgreementTemplatetAggregatorForm;
    }
  | {
      content: string;
      type:
        | TEMPLATE_TYPE.contract
        | TEMPLATE_TYPE.section
        | TEMPLATE_TYPE.paragraphSection
        | IDistributionType;
    }
);

export type IDistributionType =
  | TEMPLATE_TYPE.digitalDistribution
  | TEMPLATE_TYPE.physicalDistribution
  | TEMPLATE_TYPE.channelDistribution
  | TEMPLATE_TYPE.merchDistribution;

export interface IContractTemplateDetailItemForm {
  id: string;
  content: IAgreementTemplatetAggregatorForm;
  selectOptionActiveId?: number;
}

export interface IContractCustomTemplateForm {
  search: string;
  parentId: string;
  selectedId?: string;
  isLoading?: boolean;
  type: TEMPLATE_TYPE;
  agreementKind?: 'text' | 'paragraph';
}

export interface IContractSideMenuForm {
  displayed?: boolean;
  type: SIDE_MENU_TYPE;
  customTemplate?: IContractCustomTemplateForm;
  detail?: IContractTemplateDetailItemForm;
}

export interface IContractDetailsForm extends Omit<IContractBase, 'title'> {
  withEndDate?: boolean;
  status: CONTRACT_STATUS;
}

export interface IContractTemplateForm extends IVersion {
  items: IContractTemplateTreeItemForm[];
  activeId: string | null;
  overId: string | null;
  sideMenu: IContractSideMenuForm | null;
  offsetLeft: number;
  details?: IContractDetailsForm;
}

export type IContractTemplateFlattenedTreeForm = {
  parentId: null | string;
  depth: number;
  index: number;
} & IContractTemplateTreeItemForm;

export type SensorContext = MutableRefObject<{
  items: IContractTemplateFlattenedTreeForm[];
  offset: number;
}>;

export interface IContractFormikStatus {
  namePrefix: string;
  displayMode?: boolean;
  indicator?: boolean;
  indentationWidth: number;
  maxDepth: number;
  minDepth: number;
  hideContract?: boolean;
}

export interface ITemplatesLightListItem {
  id: string;
  title?: string;
}

export enum TEMPLATE_TYPE {
  agreement = 1,
  digitalDistribution = 2,
  section = 3,
  contract = 4,
  physicalDistribution = 5,
  merchDistribution = 6,
  channelDistribution = 7,
  paragraphSection = 8,
}

export enum SETTLEMENT_TYPE {
  Percentage = 1,
  PerUnit = 2,
}

export enum SIDE_MENU_TYPE {
  agreementDetail = 1,
  customTemplatesList = 2,
}

export interface ITemlatesSearch extends IInfinitePageParams {}

export interface ITemplateListItem {
  id: string;
  title: string;
  type: { id: TEMPLATE_TYPE };
}

export interface ITemplatesInfiniteResponse
  extends IInfinitePageResponse<ITemplateListItem> {}

export interface IDistributionSharesResponse {
  salesChannelId: string;
  percentage?: number | null;
  percent?: number | null;
  amountPerUnit?: number | null;
  salesChannelName: string;
}

export interface IDistributionResponse {
  defaultSharePercentage?: number | null;
  defaultAmountPerUnit?: number | null;
  settlementType?: SETTLEMENT_TYPE;
  position: number;
  title: string;
  id?: string;
  shares: IDistributionSharesResponse[];
}

export interface IDistributionSharesMutation {
  salesChannelId: string;
  percent?: number;
  amountPerUnit?: number;
}

export interface IDistributionMutation {
  title: string;
  position: number;
  settlementType: SETTLEMENT_TYPE;
  defaultShares?: number;
  defaultAmountPerUnit?: number;
  distributionTemplateShares: IDistributionSharesMutation[];
}
